// extracted by mini-css-extract-plugin
export var divider = "_n8-0";
export var systemMessage = "_n8-1";
export var systemMessageWrapper = "_n8-2";